//=include _owl.carousel.min.js
//=include _jquery.fancybox.min.js

$(document).ready(function() {
	$('#carrousel_team').owlCarousel({
		loop: true,
		lazyLoad: true,
		autoplay: true,
		autoplayTimeout: 4000,
		margin: 20,
		dots: false,
		nav: false,
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 2
			},
			1024: {
				items: 3
			}
		}
	});

	Fancybox.bind('[data-fancybox="video"]', {

	});
});
